import http from "./axios";

export default {
  async getActivities() {
    try {
      return await http.get(`/api/activities`);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
};
